export default function PageBand(props) {
  let newProps = { ...props };
  newProps.className = "px-xl-5 px-3 py-xl-5 py-3 w-100 " + newProps.className;
  return <div {...newProps} tabIndex="0"></div>;
}
